// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plannings {
  position: relative;
  width: 100%;
  padding: 24px 0 0;
  margin-bottom: 56px;
}
.plannings .modal-default.dialog-alert .title {
  font-size: 16px;
}
.plannings .modal-default.dialog-alert .wrapper-modal {
  max-width: 405px;
}
.plannings .modal-default.dialog-alert .dialog-alert__description {
  font-size: 14px;
}
.plannings .modal-default.dialog-alert .dialog-alert__description strong {
  font-size: inherit;
}
.plannings .modal-default.dialog-alert .dialog-alert__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-top: 24px;
}
.plannings .modal-default.dialog-alert .dialog-alert__buttons button {
  min-height: 32px;
  padding: 5px 12px;
}
.plannings .modal-default.dialog-alert .dialog-alert__buttons span {
  font-size: 14px;
}
.plannings .notes-modal {
  border-top: 1px solid var(--sebrae-light-gray4);
  padding-top: 24px;
}
.plannings .notes-modal span {
  font-weight: bold;
}
.plannings .more-planning {
  text-align: center;
  margin-bottom: 30px;
}
.plannings .more-planning button {
  color: var(--sebrae-blue-7);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
}
.plannings .list-planning, .plannings .trash-planning {
  position: relative;
}
.plannings .list-planning .wrapper-loading-small, .plannings .trash-planning .wrapper-loading-small {
  height: 100%;
}
.plannings .list-planning .accordion-section, .plannings .trash-planning .accordion-section {
  margin: 24px 0;
}
.plannings .list-planning .empty, .plannings .trash-planning .empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-size: 13px;
  color: var(--sebrae-gray);
  padding: 50px 0;
}
.plannings .trash-planning .accordion {
  padding: 10px;
}
.plannings .trash-planning .accordion-title {
  font-size: 14px;
}
@media screen and (min-width: 768px) {
  .plannings .trash-planning .accordion {
    padding: 15px;
  }
  .plannings .trash-planning .accordion-title {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/plannings/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AACF;AAGM;EACE,eAAA;AADR;AAGM;EACE,gBAAA;AADR;AAIQ;EACE,eAAA;AAFV;AAIU;EACE,kBAAA;AAFZ;AAKQ;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAHV;AAKU;EACE,gBAAA;EACA,iBAAA;AAHZ;AAKU;EACE,eAAA;AAHZ;AASE;EACE,+CAAA;EACA,iBAAA;AAPJ;AASI;EACE,iBAAA;AAPN;AAWE;EACE,kBAAA;EACA,mBAAA;AATJ;AAWI;EACE,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AATN;AAaE;EACE,kBAAA;AAXJ;AAaI;EACE,YAAA;AAXN;AAaI;EACE,cAAA;AAXN;AAaI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAXN;AAeI;EACE,aAAA;AAbN;AAeI;EACE,eAAA;AAbN;AAgBI;EACE;IACE,aAAA;EAdN;EAgBI;IACE,eAAA;EAdN;AACF","sourcesContent":[".plannings {\n  position: relative;\n  width: 100%;\n  padding: 24px 0 0;\n  margin-bottom: 56px;\n\n  .modal-default {\n    &.dialog-alert {\n      .title {\n        font-size: 16px;\n      }\n      .wrapper-modal {\n        max-width: 405px;\n      }\n      .dialog-alert {\n        &__description {\n          font-size: 14px;\n\n          strong {\n            font-size: inherit;\n          }\n        }\n        &__buttons {\n          display: flex;\n          justify-content: flex-end;\n          gap: 24px;\n          margin-top: 24px;\n\n          button {\n            min-height: 32px;\n            padding: 5px 12px;\n          }\n          span {\n            font-size: 14px;\n          }\n        }\n      }\n    }\n  }\n  .notes-modal {\n    border-top: 1px solid var(--sebrae-light-gray4);\n    padding-top: 24px;\n\n    span {\n      font-weight: bold;\n    }\n  }\n\n  .more-planning {\n    text-align: center;\n    margin-bottom: 30px;\n\n    button {\n      color: var(--sebrae-blue-7);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      text-decoration-line: underline;\n    }\n  }\n\n  .list-planning, .trash-planning {\n    position: relative;\n\n    .wrapper-loading-small {\n      height: 100%;\n    }\n    .accordion-section {\n      margin: 24px 0;\n    }\n    .empty {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 15px;\n      font-size: 13px;\n      color: var(--sebrae-gray);\n      padding: 50px 0;\n    }\n  }\n  .trash-planning {\n    .accordion {\n      padding: 10px;\n    }\n    .accordion-title {\n      font-size: 14px;\n    }\n\n    @media screen and (min-width: 768px) {\n      .accordion {\n        padding: 15px;\n      }\n      .accordion-title {\n        font-size: 16px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
